// extracted by mini-css-extract-plugin
export default {"navigateBtnCol":"oneWayInterviewConfiguration_navigateBtnCol__0qnAr","dividerLine":"oneWayInterviewConfiguration_dividerLine__Tn8hX"};